export default __webpack_public_path__ + "static/media/Pretendard-Black.subset.f3fa2b26.woff2";